import RepackingControlCard from '@/models/Repacking/RepackingControlCard';

export default class RepackingControlCardFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.repackingId  = '';
		this.repackingRepackingNo = '';
		this.repackingDetailId  = '';
		this.repackingDetailDeliveryInstructionDetail = '';
		this.controlCardId  = '';
		this.controlCardControlCardNumber = '';
		this.scanById  = '';
		this.scanByFirstName = '';
		this.scanDateFrom = '';
		this.scanDateTo = '';
		this.qty = '';
		this.qtyOriginal = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			repackingId : '0',
			repackingRepackingNo : '0',
			repackingDetailId : '0',
			repackingDetailDeliveryInstructionDetail : '0',
			controlCardId : '0',
			controlCardControlCardNumber : '0',
			scanById : '0',
			scanByFirstName : '0',
			scanDateFrom : '0',
			scanDateTo : '0',
			qty : '0',
			qtyOriginal : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}